import React from "react";

const Footer = () => {
   return (
      <div>
         <p>
            <small>© copyright worldnews</small>
         </p>
      </div>
   );
};

export default Footer;
